import React from "react";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import "../Board/NoticeDetail.scss";
import "../CustomerBoard/CustomerqaDetail.scss";
import ConfirmModal from "../../components/ConfirmModal";
import Loading from "../../components/Loading";
import EditModal from "../../components/EditModal";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";
import { MdClose } from "react-icons/md";
export default function StepperDetail({ activeStep, firstStep }) {
  const { state } = useLocation();

  const { id } = useParams();
  let navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [fileData, setFileData] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [visible, setVisible] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [decodedId, setDecodedId] = useState("");
  const closeModal = () => {
    setShowModal(false);
  };
  const closeModal2 = () => {
    setShowModal2(false);
  };
  const closeModal3 = () => {
    setShowModal3(false);
  };
  const closeModal4 = () => {
    setComment("");
    setFileData([]);
    setShowModal4(false);
  };

  const [radioValue, setRadioValue] = useState("");
  const radioHandler = (event) => {
    setRadioValue(event.target.value);
  };
  const onChangeHandler = (event) => {
    setComment(event.target.value);
  };
  const getDownloadData = async () => {
    const response = await axios.get(`/api/apply-proc-board/${id}`);
    setDetailData(response.data);
  };
  useEffect(() => {
    setDecodedId(jwtDecode(window.sessionStorage.getItem("token")).sub);
    getDownloadData();
  }, []);
  const fileUploadHandler = (event) => {
    const maxSize = 200 * 1024 * 1024;
    if (event.target.files[0].size > maxSize) {
      return Swal.fire({
        icon: "error",
        title: "오류",
        text: "파일용량은 200MB를 넘을수없습니다",
        confirmButtonColor: "dodgerBlue",
      });
    }

    setFileData((state) => {
      return [...state, event.target.files[0]];
    });
  };
  const deleteFileHandler = (e) => () => {
    let tempFile = fileData.filter((el) => el.name !== e.name);
    setFileData(tempFile);
  };
  const resetFileHandler = (event) => {
    event.target.value = null;
  };
  const uploadHandler = async () => {
    window.scrollTo(0, 0);
    setVisible(true);
    if (firstStep > activeStep) {
      setVisible(false);
      return setShowModal(true);
    }
    if (fileData.length === 0) {
      try {
        let tempObj = detailData;
        if (tempObj.state === 11) {
          tempObj.state = 12;
        } else if (tempObj.state === 91) {
          tempObj.state = 92;
        } else if (tempObj.state === 94) {
          tempObj.state = 95;
        }

        tempObj.type = 1;
        if (radioValue === "yes") {
          tempObj.comment = "동의합니다.";
        } else if (radioValue === "no") {
          tempObj.comment = "동의하지않습니다." + "  " + comment;
        } else {
          tempObj.comment = comment;
        }
        const response2 = await axios.patch(
          `/api/apply-proc-board/${id}`,
          tempObj
        );
        setShowModal4(false);
        setComment("");
        getDownloadData();
        return setVisible(false);
      } catch (error) {
        console.log(error);
      }
    }
    const formData = new FormData();
    for (let i = 0; i < fileData.length; i++) {
      formData.append("files", fileData[i]);
    }
    // formData.append("files", fileData);
    try {
      const response = await axios.post(
        `/api/apply-proc-board/${id}/docs/multi`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setShowModal3(true);
      getDownloadData();
      let tempObj = detailData;
      if (tempObj.state === 11) {
        tempObj.state = 12;
      } else if (tempObj.state === 91) {
        tempObj.state = 92;
      } else if (tempObj.state === 94) {
        tempObj.state = 95;
      }
      tempObj.type = 1;
      if (radioValue === "yes") {
        tempObj.comment = "동의합니다.";
      } else if (radioValue === "no") {
        tempObj.comment = "동의하지않습니다." + "  " + comment;
      } else {
        tempObj.comment = comment;
      }
      const response2 = await axios.patch(
        `/api/apply-proc-board/${id}`,
        tempObj
      );
      setComment("");
      setShowModal4(false);
      getDownloadData();
      setVisible(false);
    } catch (err) {
      setVisible(false);
      console.log(err);
    }
  };
  return (
    <div>
      {visible && <Loading visible={visible} />}

      {showModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"진행단계"}
          content={`이전단계는 수정이 불가합니다.`}
        />
      ) : null}
      {showModal2 ? (
        <ConfirmModal
          closeModal={closeModal2}
          modalTitle={"다운로드"}
          content={`파일이 없습니다.`}
        />
      ) : null}
      {showModal3 ? (
        <ConfirmModal
          closeModal={closeModal3}
          modalTitle={"완료"}
          content={`조치결과 답변 완료`}
        />
      ) : null}
      {showModal4 === true ? (
        <div className="popup_bg_bbs " onClick={closeModal}>
          <div
            className="password_change "
            style={{ width: "500px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>시정조치 답변등록</h1>
            </div>
            <section className="customcenter_title_row">
              <div
                className="select_box select_box_first"
                style={{ marginLeft: "50px", marginTop: "10px" }}
              >
                <div
                  className="help_prev_list"
                  style={{ backgroundColor: "#f3f3f3", width: "500px" }}
                >
                  <input
                    style={{ display: "none", width: "100%" }}
                    className="input_box file_input"
                    type="file"
                    id="file"
                    onChange={fileUploadHandler}
                    onClick={resetFileHandler}
                  />
                  <label
                    style={{
                      height: "100%",
                      width: "100px",
                      color: "black",
                      cursor: "pointer",
                    }}
                    htmlFor="file"
                    className="file_label"
                  >
                    <strong>파일업로드</strong>
                  </label>
                  <div>
                    <ul>
                      {fileData?.length === 0 ? (
                        <li>파일을 선택해주세요</li>
                      ) : (
                        <>
                          {fileData?.map((e, idx) => {
                            return (
                              <li key={idx}>
                                <>{e.name}</>
                                <button
                                  style={{
                                    marginLeft: "1vw",
                                    verticalAlign: "sub",
                                  }}
                                  type="button"
                                >
                                  <MdClose onClick={deleteFileHandler(e)} />
                                </button>
                                <br />
                              </li>
                            );
                          })}
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {detailData.state.toString()[0] === "9" ? (
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div>
                    <strong>처리결과 동의/미동의:</strong>
                  </div>
                  <div className="radio_">
                    <input
                      name="yn"
                      value="yes"
                      type="radio"
                      onChange={radioHandler}
                    />
                    <label htmlFor="yn">동의</label>
                  </div>
                  <div className="radio_">
                    <input
                      name="yn"
                      value="no"
                      type="radio"
                      onChange={radioHandler}
                    />
                    <label htmlFor="yn">비동의</label>
                  </div>
                </div>
              </>
            ) : null}

            <div style={{ padding: "0px 20px 20px 20px" }}>
              <div>
                <textarea
                  disabled={radioValue === "yes"}
                  onChange={onChangeHandler}
                  value={comment}
                  name="textarea1"
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    margin: "1rem 0",
                    padding: "10px",
                    height: "200px",
                  }}
                  type="textarea"
                  placeholder="사유를 입력해주세요"
                  spellCheck="false"
                />
              </div>
              <div style={{ color: "red", marginBottom: "1vh" }}>
                ※ {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치"}답변은
                수정/변경이 불가합니다
              </div>
              <div style={{ display: "flex", gap: "3px" }}>
                <button
                  className="btn_none"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={closeModal4}
                >
                  취소
                </button>
                <button
                  className="btn_color"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={uploadHandler}
                >
                  등록
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div>
        <div className="notice_title_wrap" style={{ borderTop: "0" }}>
          <h1 className="notice_title">
            {detailData.title}
            {detailData.comment === "" ? (
              <span
                className="btn_color"
                onClick={() => setShowModal4(true)}
                style={{ float: "right", cursor: "pointer" }}
              >
                {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치"}답변등록
              </span>
            ) : null}
          </h1>
        </div>
        <div className="notice_add_file_area">
          <div className="notice_add_file_area">
            <div
              className="notice_add_file_wrap"
              style={{ padding: "0px 0px 0px 0px" }}
            >
              <h2>첨부파일</h2>
              <div
                className="notice_addfile_wrap"
                style={{ padding: "0px 0px 0px 20px" }}
              >
                {detailData.docs
                  ?.filter((el) => el.createId !== decodedId)
                  .map((docs, idx) => {
                    return (
                      <a
                        href={`/api/apply-proc-board/${id}/doc/${docs.id}`}
                        key={idx}
                        download
                      >
                        {docs.name}
                      </a>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="notice_add_file_wrap">
            {/* <h2>시정조치신청</h2> */}
            <div
              className="help_prev_list"
              style={{
                backgroundColor: "#f3f3f3",
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <strong>담당자의견: </strong>
                <strong style={{ float: "right" }}>
                  {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치"}
                  등록일:
                  {detailData?.createAt?.substring(0, 11).replace(/-/g, ".")}
                </strong>
              </div>
              <div
                className="notice_content_row"
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    padding: "10px",
                    display: "inline-block",
                    height: "100%",
                    minHeight: "100px",
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                  }}
                  className="jodit-wysiwyg"
                  dangerouslySetInnerHTML={{ __html: detailData?.body }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* 처리방안 */}
        {detailData.comment !== "" ? (
          <div className="notice_add_file_area">
            <div className="notice_add_file_area">
              <div
                className="notice_add_file_wrap"
                style={{ padding: "0px 0px 0px 0px" }}
              >
                <h2>첨부파일</h2>
                <div
                  className="notice_addfile_wrap"
                  style={{ padding: "0px 0px 0px 20px" }}
                >
                  {detailData.docs
                    ?.filter((el) => el.createId === decodedId)
                    .map((docs, idx) => {
                      return (
                        <a
                          href={`/api/apply-proc-board/${id}/doc/${docs.id}`}
                          key={idx}
                          download
                        >
                          {docs.name}
                        </a>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="notice_add_file_wrap">
              {/* <h2>시정조치답변</h2> */}
              <div
                className="help_prev_list"
                style={{
                  backgroundColor: "#E3F0FF",
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <strong>
                    {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치"}
                    답변:{" "}
                  </strong>
                  <strong style={{ float: "right" }}>
                    답변등록일:
                    {detailData?.updateAt?.substring(0, 11).replace(/-/g, ".")}
                  </strong>
                </div>
                <div
                  className="notice_content_row"
                  style={{
                    backgroundColor: "white",
                    width: "100%",
                  }}
                >
                  <div
                    className="scroll_bar"
                    style={{
                      padding: "10px",
                      display: "inline-block",
                      minHeight: "100px",
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    {detailData.comment}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
